document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.kol-video-section').forEach((section) => {
        const track = section.querySelector('[data-kol-track]');
        const prevButton = section.querySelector('[data-kol-prev]');
        const nextButton = section.querySelector('[data-kol-next]');
        const mediaAreas = section.querySelectorAll('.kol-video-card__media');
        const togglePoster = (video, isVisible) => {
            const poster = video
                ?.closest('.kol-video-card__media')
                ?.querySelector('.kol-video-card__poster');

            if (!poster) return;

            poster.classList.toggle('is-hidden', !isVisible);
        };

        mediaAreas.forEach((media) => {
            media.addEventListener('click', (event) => {
                const card = media.closest('.kol-video-card');
                const video = card?.querySelector('video');
                const button = media.querySelector('[data-kol-play]');

                if (!video) return;
                if (event.target.closest('video')) return;

                section.querySelectorAll('video').forEach((otherVideo) => {
                    if (otherVideo !== video) {
                        otherVideo.pause();

                        const otherButton = otherVideo
                            .closest('.kol-video-card')
                            ?.querySelector('[data-kol-play]');

                        if (otherButton) {
                            otherButton.style.display = '';
                        }

                        togglePoster(otherVideo, true);
                    }
                });

                if (video.paused) {
                    video.play().then(() => {
                        if (button) {
                            button.style.display = 'none';
                        }

                        togglePoster(video, false);
                    });
                } else {
                    video.pause();

                    if (button) {
                        button.style.display = '';
                    }

                    togglePoster(video, true);
                }
            });
        });

        section.querySelectorAll('video').forEach((video) => {
            const button = video
                .closest('.kol-video-card')
                ?.querySelector('[data-kol-play]');

            video.addEventListener('play', () => {
                section.querySelectorAll('video').forEach((otherVideo) => {
                    if (otherVideo !== video && !otherVideo.paused) {
                        otherVideo.pause();
                    }
                });

                if (button) {
                    button.style.display = 'none';
                }

                togglePoster(video, false);
            });

            video.addEventListener('playing', () => {
                if (button) {
                    button.style.display = 'none';
                }

                togglePoster(video, false);
            });

            video.addEventListener('pause', () => {
                if (button && !video.ended) {
                    button.style.display = '';
                }

                togglePoster(video, true);
            });

            video.addEventListener('ended', () => {
                if (button) {
                    button.style.display = '';
                }

                togglePoster(video, true);
            });
        });

        if (!track) return;

        const updateScrollableState = () => {
            const isScrollable = track.scrollWidth - track.clientWidth > 2;
            section.classList.toggle('kol-video-section--scrollable', isScrollable);
            return isScrollable;
        };

        if (!prevButton || !nextButton) {
            updateScrollableState();
            window.addEventListener('resize', updateScrollableState);
            return;
        }

        const getScrollAmount = () => {
            const card = track.querySelector('[data-kol-card]');

            if (!card) return 0;

            const style = window.getComputedStyle(track);
            const gap =
                parseFloat(style.columnGap) ||
                parseFloat(style.gap) ||
                0;

            return card.getBoundingClientRect().width + gap;
        };

        const updateButtons = () => {
            updateScrollableState();

            const maxScroll = track.scrollWidth - track.clientWidth;

            prevButton.disabled = track.scrollLeft <= 2;
            nextButton.disabled = track.scrollLeft >= maxScroll - 2;
        };

        prevButton.addEventListener('click', () => {
            track.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
            });
        });

        nextButton.addEventListener('click', () => {
            track.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        });

        track.addEventListener('scroll', updateButtons, {
            passive: true
        });

        window.addEventListener('resize', updateButtons);

        updateButtons();
    });
});
